import { Step } from "react-joyride";

const closeProjectFilesModal = () => {
  (document.querySelector(".tour-project-files-modal-close") as HTMLElement | null)?.click();
};

const proposalInfoPageTourSteps: Step[] = [
  {
    target: ".tour-update-proposal",
    content:
      "Sets the proposal to Draft status and allows you to edit the proposal. Any previously links to the proposal sent to the customer will expire.",
  },
  {
    target: ".tour-move-to-closed-won",
    content: "Select to move the Proposal to Won status.",
  },
  {
    target: ".tour-move-to-closed-lost",
    content: "Select to move the Proposal to Lost status.",
  },
  {
    target: ".tour-move-to-on-hold",
    content:
      "Select to place the Proposal on Hold. This is often used when the customer agreed to the proposal, but cannot mark it Won until later in the year. This does not impact your dashboard metrics.",
  },
  {
    target: ".tour-cancel-proposal",
    content:
      "Select to cancel the Proposal. Cancelled Proposals do not affect Sales and Dashboard Metrics.",
  },
  {
    target: ".tour-duplicate-proposal",
    content: "Select to duplicate the Proposal. This creates a separate Proposal.",
  },
  {
    target: ".tour-download-proposal",
    content: "Select to generate and save a PDF of the Proposal to your computer.",
  },
  {
    target: ".tour-view-proposal",
    content: "Select to view the Proposal as the customer will see it.",
  },
  {
    target: ".tour-view-proposal-breakdown",
    content: "Allows you to see the proposal numbers without changing the Proposal Status.",
  },
  {
    target: ".tour-salesperson",
    placement: "right",
    content: "The current salesperson on this proposal. Select the drop-down arrow to reassign.",
  },
  {
    target: ".tour-contact",
    placement: "right",
    content: "The main contact for this proposal. Select the drop-down arrow to change the contact.",
  },
  {
    target: ".tour-source",
    placement: "right",
    content:
      "Optional. Shows you where the opportunity originated. You may use the drop-down menu to select a source.",
  },
  {
    target: ".tour-layout",
    placement: "right",
    content: "Choose how you’d like your Proposal to appear for the customer.",
  },
  {
    target: ".tour-forecasting-fields",
    content: "Both optional. Completing these fields will help you monitor your sales pipeline.",
  },
  {
    target: ".tour-project-files-edit",
    content:
      "Click here to add files for this project. Your uploaded files stay private inside the system. They only become visible to others if you manually add them to a Proposal.",
    after: closeProjectFilesModal,
  },
  {
    target: ".tour-pricing-checkboxes",
    content: "Selecting either box will change how the pricing appears on the proposal.",
  },
  {
    target: ".tour-proposal-info-save",
    content: "Click here to save any changes you have made.",
  },
  {
    target: ".tour-add-recipients",
    content: "You can add (+) or remove (trash icon) additional recipients using these buttons.",
  },
  {
    target: ".tour-activity-section",
    content:
      "Here you can track how the customer is viewing and interacting with your Proposal. You can also log activities like calls, emails and follow-ups with the customer. You may also create Tasks as follow-up reminders.",
  },
];

export default proposalInfoPageTourSteps;
